module.exports = __webpack_public_path__ + "assets/5f0808f0b558e67eed08367106d75f2e.png";